<template>
    <div v-if="config">
        <setting-card
            v-bind="binds"
            v-model:active="config.jeDeclareDotCom"
            @updateProfile="updateProfile()"
            :hidePrevious="true"
            :hideMoreVert="true"
        >
            <v-container class="px-6 pb-6">
                <v-row class="d-flex justify-center pb-2">
                    <v-col cols="6"> </v-col>
                </v-row>
                <v-row class="d-flex justify-center pb-2">
                    <v-col cols="12">
                        <v-text-field-filled
                            v-model="config.jeDeclareDotComConfig.auth.username"
                            hide-details
                            outlined
                            autocomplete="off"
                            label="Login"
                            density="compact"
                        />
                    </v-col>
                </v-row>
                <v-row class="d-flex justify-center">
                    <v-col cols="12">
                        <v-text-field-filled
                            v-model="config.jeDeclareDotComConfig.auth.password"
                            hide-details
                            outlined
                            autocomplete="off"
                            type="password"
                            label="Mot de passe"
                            density="compact"
                        />
                    </v-col>
                </v-row>
                <v-row class="d-flex justify-center">
                    <v-col cols="12" class="text-red">
                        {{ JDCError }}
                    </v-col>
                </v-row>
            </v-container>
            <v-overlay
                :absolute="true"
                :model-value="JDCConnectionOnTest || JDCConnectionTestSuccess"
            >
                <v-progress-circular v-if="JDCConnectionOnTest" indeterminate color="primary" />
                <template v-else>
                    <v-icon color="secondary" size="x-large" v-if="JDCConnectionTestSuccess">
                        $fa-check
                    </v-icon>
                    <v-icon color="error" size="x-large" v-else> $fa-times </v-icon>
                </template>
            </v-overlay>
        </setting-card>
    </div>
</template>

<script lang="ts">
import settingCard from "../SettingCard.vue";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";
import JDCImg from "../../../assets/img/settings-icons/jedeclare.png";

@Component({
    components: {
        settingCard,
    },
    emits: ["updateProfile"],
})
export class SettingJeDeclare extends Vue {
    @Prop({ default: null }) config!: any;
    @Prop({ default: null }) JDCConnectionOnTest!: any;
    @Prop({ default: null }) JDCConnectionTestSuccess!: any;

    get binds() {
        return {
            title: "Récupération des relevés bancaires",
            partnerName: "JeDeclare.com",
            text: "Utilisez JeDeclare.com pour récupérer les relevés bancaires au format EBICS",
            logo: JDCImg,
        };
    }

    get JDCError() {
        if (
            this.config &&
            this.config.jeDeclareDotComConfig &&
            this.config.jeDeclareDotComConfig.error &&
            this.config.jeDeclareDotComConfig.error.message
        ) {
            return this.config.jeDeclareDotComConfig.error.message;
        }
        return null;
    }

    updateProfile() {
        this.$emit("updateProfile");
    }

    validCategory = ["ALL", "BANK"];

    searchCondition(search: string) {
        return (
            this.binds.title.toLowerCase().includes(search.toLowerCase()) ||
            this.binds.partnerName.toLowerCase().includes(search.toLowerCase()) ||
            this.binds.text.toLowerCase().includes(search.toLowerCase())
        );
    }

    displayCondition(
        search = "",
        tab: "ALL" | "BANK" | "MAIL" | "INVOICE" | "PAYEMENT" | "OTHER" = "ALL",
    ) {
        if (search) {
            return this.validCategory.includes(tab) && this.searchCondition(search);
        }
        return this.validCategory.includes(tab);
    }
}

export default toNative(SettingJeDeclare);
</script>
